import React, { useState } from "react";
import { FaCheckCircle, FaTimesCircle, FaRunning } from "react-icons/fa";
import axios from "axios";
import s from "../styles/UpdateXmlButton.module.css";

const OneProjectToCheckTable = ({ projectId }) => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("idle"); // idle | success | error
  const [errorMessage, setErrorMessage] = useState("");

  const handleUpdate = async () => {
    setLoading(true);
    setStatus("idle");
    setErrorMessage("");

    try {
      const res = await axios.post("/to_google_check_table_one_project", {
        project_id: projectId,
      });

      const result = res.data?.result;

      if (result === "success") {
        setStatus("success");
      } else {
        setStatus("error");
        setErrorMessage(result || "Неизвестная ошибка");
      }

    } catch (err) {
      setStatus("error");
      setErrorMessage("Ошибка сети или сервера");
    } finally {
      setLoading(false);
      setTimeout(() => {
        setStatus("idle");
        setErrorMessage("");
      }, 3000);
    }
  };

  const renderIcon = () => {
    if (status === "success") return <FaCheckCircle className={s.icon_success} />;
    if (status === "error") return (
      <FaTimesCircle
        className={s.icon_error}
        title={errorMessage}
      />
    );
    return <FaRunning className={`${s.icon} ${loading ? s.spin : ""}`} />;
  };

  return (
    <div
      className={s.icon_wrapper}
      onClick={!loading ? handleUpdate : null}
      title="Отправить в бегунок"
    >
      {renderIcon()}
    </div>
  );
};

export default OneProjectToCheckTable;
